import React from "react";
import { useNavigate } from "react-router-dom";
import Body from "src/components/common/Body";
import Box from "src/components/common/Box";
import Button from "src/components/common/Button";
import SVG from "src/utils/SVG";
import styled from "styled-components";
import bgError from "src/assets/images/bgError.svg";

function error() {
  const navigate = useNavigate();
  const goBack = () => {
    navigate("/home");
  };

  return (
    <>
      <Body type="login">
        <CommonErrorSet>
          <div className="flex-item">
            <SVG name="error" width={230} height={230} viewBox="0 0 230 230" />
            <div>
              <p className="stress-mes">요청하신 페이지를 찾을 수 없습니다</p>
              <p>
                주소가 잘못 입력되었거나
                <br />
                삭제되어 페이지를 찾을 수 없습니다.
                <br />
                입력하신 주소가 정확한지 다시 한번 확인해주세요.
                <br />
                <br />
                관련 문의사항은 F&amp;F 본사
                <br />
                웹플랫폼팀(02-520-6464)에 문의 바랍니다.
              </p>
              <Box pd="30px 0 0">
                <StyledButton variant="contained" br="round" onClick={goBack}>
                  홈으로 가기
                </StyledButton>
              </Box>
            </div>
          </div>
        </CommonErrorSet>
      </Body>
    </>
  );
}

const CommonErrorSet = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin("column", "flex-start", "center")}
  height: 100%;
  padding-top: 80px;
  .flex-item {
    position: relative;
    width: 100%;
    padding: 185px 15px 0;
    text-align: center;
    > svg {
      position: absolute;
      top: 0;
      left: 50%;
      display: inline-block;
      width: 230px;
      height: 230px;
      margin-left: -115px;
    }
    > div {
      padding: 60px 0 25px;
      border: 1px solid ${({ theme }) => theme.color.warning};
      border-left: none;
      border-right: none;
      background: url(${bgError}) no-repeat 0 40px;
      color: #4c5b70;
      font-size: 15px;
      line-height: 22px;
      .stress-mes {
        margin-bottom: 20px;
        font-size: 15px;
        font-weight: 700;
        color: ${({ theme }) => theme.color.warning};
      }
    }
  }
`;

const StyledButton = styled(Button)`
  background: ${({ theme }) => theme.color.warning};
  color: #fff;
`;

export default error;
